module.exports = __webpack_public_path__ + "static/media/alexx.e2970206.csv";